<template>
  <div id="home">
    <div class="block-cover">
      <HeaderGeneral banner="pers-home.jpg"/>
    </div> 
    
    <div id="nav">
        <Nav :links="links" v-on:launch-gallery="launchGallery"/>
    </div>
    
    <img src="../assets/airdutemps.png" class="airdutemps"/>
    <img src="../assets/paris-75.png" class="paris-75"/>
    
  </div>
</template>

<style lang="scss" scoped>
  .airdutemps {
    position: absolute;
    z-index: 2;
    width: 444px;
    height: auto;
    bottom: 400px;
    right: 72px;
    @media (min-width: 992px) {
      right: 69px;
      bottom: 204px;
    }
  }
  .paris-75 {
    position: absolute;
    z-index: 2;
    width: 79px;
    height: auto;
    bottom: 398px;
    right: 30px;
    @media (min-width: 992px) {
      right: 29px;
      bottom: 205px;
    }
  }
</style>
 
<script>
// @ is an alias to /src
  import HeaderGeneral from '@/components/Header.vue'
  import Nav from '@/components/Nav.vue'
  import 'lightgallery.js';
  import 'lg-thumbnail.js';
  //import 'lg-video.js';
  import 'lg-hash.js';
  import 'lightgallery.js/dist/css/lightgallery.css';
  
  export default {
    name: 'Home',
    components: {
      HeaderGeneral,
      Nav
    },
    data () {
      return {
        links: [
          {
            title: "La résidence en image",
            path: 'EnImages',
            icon: 'la-residence-en-image.svg'
          },
          {
            title: "Labels, Innovation et Services",
            path: 'Labels',
            icon: 'labels-innovation.svg'
          },
          {
            title: "Les acteurs du projet",
            path: 'Acteurs',
            icon: 'les-acteurs-du-projet.svg'
          },
          {
            title: "Maquette orbitale",
            path: 'Maquette',
            icon: 'maquette-orbitale.svg'
          },
          {
            title: "Le quartier en un coup d'oeil",
            path: 'none',
            icon: 'le-quartier.svg'
          },
          {
            title: "Tous les détails de votre futur appartement",
            path: 'Appartement',
            icon: 'tous-les-details.svg'
          },
        ],
        galleryItems: {
          'Le quartier en un coup d\'oeil': [
            {
              src: require('../assets/plan-quartier.jpg'),
              thumb: require('../assets/plan-quartier.jpg'),
            }
          ]  
        }
      }
    },
    methods: {
      launchGallery: function(name) {
        console.log(name)
        var lg = document.querySelector('.dynamic');
        
        // Destroy gallery on close
        lg.addEventListener('onCloseAfter', function(){
          if(window.lgData[lg.getAttribute('lg-uid')] != undefined) {
            window.lgData[lg.getAttribute('lg-uid')].destroy(true);
          }
        }, false);
        
        // Init Gallery
        lightGallery(lg, 
          {
            //selector: this,
            dynamic: true,
            dynamicEl: this.galleryItems[name],
            hash: true,
            html: true,
            galleryIdl: name.length
          }
        );
        
      }
    },
  }
</script>
